import { render } from "./JWTDecoder.vue?vue&type=template&id=a70d41e8&scoped=true&ts=true"
import script from "./JWTDecoder.vue?vue&type=script&lang=ts"
export * from "./JWTDecoder.vue?vue&type=script&lang=ts"

import "./JWTDecoder.vue?vue&type=style&index=0&id=a70d41e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a70d41e8"]])

export default __exports__